export default __webpack_public_path__ + "static/media/zelda1.086ea184.jpg";